import { render, staticRenderFns } from "./ecosystem-fearless-totals.vue?vue&type=template&id=3b831b3f&"
import script from "./ecosystem-fearless-totals.ts?vue&type=script&lang=js&"
export * from "./ecosystem-fearless-totals.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports